import { useState, useEffect, useCallback, useMemo, useRef, Suspense, lazy } from 'react'
import constants, { certifiedFaq } from '../../utilities/constants'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { Mixpanel } from '../../config/Mixpanel'
import { useDispatch, useSelector } from 'react-redux'
import { decrementTime, locationCheck, locationWithoutPermission, selectLandingPageDetails, selectRazorpayModalError, selectShowAddOnBundleModal, selectShowCancellationScreen, selectShowCartScreen, selectShowCategoryModal, selectShowCourseModal, selectShowPlacementModal, selectShowRelatedSubjectsModal, selectShowSkillList, selectTimerSeconds, selectUserDetails, setFromAnalysisPage, setRazorpayModalError, setShowCancellationScreen, setShowCartScreen, setShowCategoryModal, setShowCourseModal, setShowRelatedSubjectsModal, setUserDetails, setUserEmail, setUserName, setUserPhoneNo, setUserSkillDetails } from '../../redux/otherDetailsSlice'
import { fetchMCQAnalysis, getUserFullDetails, resetAddedQuestions, selectMCQDetails, selectQuestions, selectTypeformData, setScenarioMap, setShouldPlaySecondAudio } from '../../redux/mcqSlice'
import { getUserDetails, setAuthToken, setShowNotReferralSection } from '../../redux/authenticationSlice'
import { getProductDetails, selectPriceChart } from '../../redux/priceChartSlice'
import { toast } from 'react-toastify'
import { getRelatedSkills } from '../../redux/multiSkillSelectionSlice'
import { fetchCourseSyllabus, selectshowCertificateImageModal, setShowCertificateImageModal, setShowPlacementModal } from '../../redux/postPaymentSlice'
import { customCertifiedBundle, selectCustomBundle, selectSelectedItems } from '../../redux/searchSlice'
import { fetchRelatedJobs } from '../../redux/influencersDataSlice'
import { getLogoAndSalary, getWeeklyRanking, selectAddOns, selectAnalysisPageUtmSource, selectMakePersonaliseCourseFree, selectNewShowPlacementSupportModal, selectPrice, selectShowNewCourseSyllabusModal, selectShowRecognisedSection, selectShowRedirectionModal, selectVisitedAnalysisCartPage, setAnalysisPageUtmSource, setFiveCertificates, setFromSavedAnalysisPage, setMakePersonaliseCourseFree, setPersonalisedSelected, setPrice, setSevenCertificates, setShowRedirectionModal, setThreeCertificates } from '../../redux/addOnSlice'
import { useAddonContext } from '../../context/AddonFeatureContext'
import { RAZORPAY_KEY } from '../../config/api_config'
import { createPaymentOrder } from '../../redux/razorPaySlice'
import useRazorpay from 'react-razorpay'
import { AnimatePresence, motion } from "motion/react"
import { ClipLoader } from 'react-spinners'
import { useInView } from 'react-intersection-observer'
import { selectBackCountInGoalTakingPage, setShowBackRouteModal } from '../../redux/unPaidUserSlice'

import NewPriceCard from './NewPriceCard'
import RemainingTime from './RemainingTime'

import GetMyCertificateButton from './GetMyCertificateButton'
import UsersModal from '../AnalysisPage/UsersModal'

import Logos from '../../components/Logos'
import MiniTimer from '../AddOnPage/MiniTimer'

import { resetAnswers, selectAnswers } from '../../redux/answersSlice'
import { BlurredScoreCanvas } from './ObsfuctaedText'

import NewRecognisedSection from './NewRecognisedSection'
import { DesktopTrendingPageLoader } from '../../components/LandingPageLoader'
import NewLoader from '../../components/NewLoader'
import { selectNewSavedData, setFromLandingPage, setNameToSavedData, setShowLandingPageTrendingSkills } from '../../redux/newSavedDataSlice'
import { resetScenarioDetails } from '../../redux/scenarioDetailsSlice'
import { resetBadgeState } from '../../redux/badgeSlice'
import { setIsPowerMinuteQuizCompleted, setOnlyQuizCompleted } from '../../redux/powerminuteSlice'

const OurCertificateHelps = lazy(() => import('./OurCertificateHelps'))
const NewProfessionalAtCompany = lazy(() => import('./NewProfessionalAtCompany'))
const NewAwardSection = lazy(() => import('./NewAwardSection'))
const CartIcon = lazy(() => import('../../components/CartIcon'))
const QuizAnalysis = lazy(() => import('./QuizAnalysis'))
const JoinUs = lazy(() => import('./JoinUs'))
const ShwetaSingh = lazy(() => import('./ShwetaSingh'))
const UnlockCertificateSection = lazy(() => import('./UnlockCertificateSection'))
const NewFaqSection = lazy(() => import('./NewFaqSection'))
const LinkedInPosts = lazy(() => import('./LinkedInPosts'))

// const RedirectionModal = lazy(() => import('../../components/RedirectionModal'))
const NewRedirectionModal = lazy(() => import('../NewMainQuiz/NewRedirectionModal'))
const preloadRedirectionModal = () => import('../NewMainQuiz/NewRedirectionModal')

const NewCartScreen = lazy(() => import('../AddOnPage/NewCartScreen'))
const preloadNewCartScreen = () => import('../AddOnPage/NewCartScreen')

const NewSkillListModal = lazy(() => import('./NewSkillListModal'))
const preloadNewSkillListModal = () => import('./NewSkillListModal')

const NewCourseDetailsModal = lazy(() => import('../AnalysisPage/NewCourseDetailsModal'))
const preloadNewCourseDetailsModal = () => import('../AnalysisPage/NewCourseDetailsModal')

const CertificateAddOnBundleModal = lazy(() => import('../AnalysisPage/CertificateAddOnBundleModal'))
const preloadCertificateAddOnBundleModal = () => import('../AnalysisPage/CertificateAddOnBundleModal')

const NewCourseSyllabusModal = lazy(() => import('./NewCourseSyllabusModal'))
const preloadNewCourseSyllabusModal = () => import('./NewCourseSyllabusModal')

const RelatedSubjectsModal = lazy(() => import('../AnalysisPage/RelatedSubjectsModal'))
const preloadRelatedSubjectsModal = () => import('../AnalysisPage/RelatedSubjectsModal')

const CertificateImageModal = lazy(() => import('../PostCertifcatePurchase/CertificateImageModal'))
const preloadCertificateImageModal = () => import('../PostCertifcatePurchase/CertificateImageModal')

const CategoryModal = lazy(() => import('../../components/CategoryModal'))
const premodalCategoryModal = () => import('../../components/CategoryModal')

const NewPlacementSupportModal = lazy(() => import('../AddOnPage/NewPlacementSupportModal'))
const preloadNewPlacementSupportModal = () => import('../AddOnPage/NewPlacementSupportModal')

const NewCancellationModal = lazy(() => import('../AddOnPage/NewCancellationModal'))
const preloadNewCancellationModal = () => import('../AddOnPage/NewCancellationModal')

const NewRecognisedSectionModal = lazy(() => import('./NewRecognisedSectionModal'))
const preloadNewRecognisedSectionModal = () => import('./NewRecognisedSectionModal')

export const costlyCertificates = ["azure", "growth marketing", "aws"]

export const cheapCertificates = ["scrum master", "sql", "advanced excel", "artificial intelligence", "data analytics", "mongo db", "certified professional data engineer", "certified aws solutions architect", "certified project management professional", "certified scrummaster", "microsoft azure cloud professional", "business analyst", "expert certification in salesforce deployment", "certified information systems security professional", "certified supply chain manager", "fundamentals of docker", "fundamentals of kubernetes", "python", "mobile developer", "seo", "jira", "digital marketing", "machine learning", "data science", "big data analytics", "cybersecurity", "ethical hacking", "blockchain development", "web development", "software development", "full stack development", "python programming", "sql & database", "aws cloud", "devops essentials", "business intelligence", "data visualization with power bi", "data visualization with tableau", "agile coaching", "lean management basics", "change management", "social media marketing", "content strategy", "motion design", "content creation", "creator economy mastery", "business communication skills", "leadership skills", "leadership skill", "operations management", "hr management", "customer success", "gaming development", "event management", "payroll management", "hr analytics", "workplace dei", "client management", "performance management systems", "hr automation"]

export const nineNintyNine = ["business management", "hospitality management", "business project management", "ai literacy", "business communication", "ai prompt engineer", "talent acquisition", "recruitment skills", "customer experience", "qa automation", "customer service", "creative thinking", "data literacy", "financial analysis", "b2b sales"]

export const fourNinetyNine = ["strategic management", "financial analyst", "excel", "tally", "brand management", "supply chain management", "risk management", "data visualization", "chatgpt prompts", "sales skills", "people management", "management accounting", "react.js developer", "executive soft skills"]

export const twoFortyNine = ["customer relationship management (crm)", "financial modeling", "business english", "docker & kubernetes", "python fundamentals", "ai & machine learning", "internet of things (iot)", "ai video editing", "graphic design with canva", "ai content creation", "game development", "information systems audit", "ux design skills", "cloud computing", "office administration", "accounting & compliance", "process improvement", "insurance sales", "javaScript developer"]

const productIds = [
    2, 3, 4, 9, 10, 11, 21, 31, 32, 33, 34, 37, 38, 39, 40
]

export const freeProductMapping = {
    businessManagement: 50,
    fourNinetyNine: 51,
    dataSchoolSQL: 47,
    costlyCertificates: 48,
    cheapCertificates: 49,
    twoFortyNine: 63,
    threeFortyNine: 80
}

export const productMapping = {
    businessManagement: 35,
    fourNinetyNine: 36,
    dataSchoolSQL: 1,
    costlyCertificates: 16,
    cheapCertificates: 17,
    twoFortyNine: 61,
    threeFortyNine: 79
}

const NewAnalysisPage = () => {

    const { token } = useParams()
    const { pathname, search } = useLocation()
    const params = new URLSearchParams(search)
    const utm_source = params.get('utm_source')

    const userDetails = useSelector(selectUserDetails)
    const landingPage = useSelector(selectLandingPageDetails)
    const typeformData = useSelector(selectTypeformData)
    const quizDetails = useSelector(selectMCQDetails)
    const priceChart = useSelector(selectPriceChart)
    const selectedSkills = useSelector(selectSelectedItems)
    const showCertificateImageModal = useSelector(selectshowCertificateImageModal)
    const showCourseModal = useSelector(selectShowCourseModal)
    const showCategoryModal = useSelector(selectShowCategoryModal)
    const showRelatedSubjectsModal = useSelector(selectShowRelatedSubjectsModal)
    const timerSeconds = useSelector(selectTimerSeconds)
    const price = useSelector(selectPrice)
    const addOns = useSelector(selectAddOns)
    const showPlacementModal = useSelector(selectShowPlacementModal)
    const showCancellationScreen = useSelector(selectShowCancellationScreen)
    const utmSource = useSelector(selectAnalysisPageUtmSource)
    const customBundle = useSelector(selectCustomBundle)
    const backCountInGoalTakingPage = useSelector(selectBackCountInGoalTakingPage)
    const showSkillList = useSelector(selectShowSkillList)
    const showNewCourseSyllabusModal = useSelector(selectShowNewCourseSyllabusModal)
    const makePersonaliseCourseFree = useSelector(selectMakePersonaliseCourseFree)
    const visitedAnalysisCartPage = useSelector(selectVisitedAnalysisCartPage)
    const showCartScreen = useSelector(selectShowCartScreen)
    const razorpayModalError = useSelector(selectRazorpayModalError)
    const showAddOnBundleModal = useSelector(selectShowAddOnBundleModal)
    const newShowPlacementSupportModal = useSelector(selectNewShowPlacementSupportModal)
    const mcQuestions = useSelector(selectQuestions)
    const answers = useSelector(selectAnswers)
    const showRecognisedSection = useSelector(selectShowRecognisedSection)
    const showRedirectionModal = useSelector(selectShowRedirectionModal)
    const newSavedData = useSelector(selectNewSavedData)
    
    const userName = userDetails?.user_name
    const firstName = userName?.split(" ")?.[0]
    const skillName = landingPage?.skill_name
    const email = userDetails?.email
    const phoneNo = userDetails?.phone_no
    const score = quizDetails?.quiz_score
    const minutes = Math.floor(timerSeconds/60)
    const seconds = timerSeconds%60
    const quizAnalysis = quizDetails?.quiz_analysis
    const fromLandingPage = newSavedData?.fromLandingPage
    const newSavedEmail = newSavedData?.email
    const newSavedPhoneNo = newSavedData?.phoneNo
    const countryCode = newSavedData?.countryCode
    const insufficientFundsError = razorpayModalError === 'insufficient_funds'

    const { threeCertificates, fiveCertificates, sevenCertificates, proMembershipSelected, personalisedSelected, fourWeekPlacementFeature, fromSavedAnalysisPage } = addOns

    const [ isVisible, setIsVisible ] = useState(false)
    const [ isModalOpen, setIsModalOpen ] = useState(false)
    const [ ourUsersModal, setOurUsersModal ] = useState(false)
    const [ swiperInstance, setSwiperInstance ] = useState(null)
    const [ index, setIndex ] = useState(0)

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const Razorpay = useRazorpay()
    const scrollTimeout = useRef(null)

    const skillIsBusinessManagement = nineNintyNine?.includes(skillName?.toLowerCase())
    const { skillIsNotSeo } = useAddonContext()

    const { ref, inView } = useInView({
        threshold: 0.5,   // Start animation when 50% of the component is visible
    })

    const handleScroll = () => {
        if (isVisible) setIsVisible(false)

        if (scrollTimeout.current) clearTimeout(scrollTimeout.current)

        scrollTimeout.current = setTimeout(() => {
            setIsVisible(true)
        }, 1000)
    }

    useEffect(() => {
        preloadRedirectionModal()
        preloadNewCartScreen()
        premodalCategoryModal()
        preloadNewSkillListModal()
        preloadNewCancellationModal()
        preloadRelatedSubjectsModal()
        preloadCertificateImageModal()
        preloadNewCourseDetailsModal()
        preloadNewCourseSyllabusModal()
        preloadNewPlacementSupportModal()
        preloadCertificateAddOnBundleModal()
        preloadNewRecognisedSectionModal()
    }, [])

    useEffect(() => {
        if(!email && !phoneNo){
            dispatch(setUserEmail(newSavedEmail))
            dispatch(setUserPhoneNo(countryCode+newSavedPhoneNo))
        }
    }, [countryCode, dispatch, email, newSavedEmail, newSavedPhoneNo, phoneNo])

    useEffect(() => {
        if (typeformData?.is_paid){
            if (backCountInGoalTakingPage === 1){
                dispatch(setShowBackRouteModal(true))
            }
            return navigate('/analysis/leaderboard/un-paid')
        }
    }, [backCountInGoalTakingPage, dispatch, navigate, typeformData?.is_paid])

    useEffect(() => {
        const handleBackButton = (e) => {
            e.preventDefault()
            if(showRelatedSubjectsModal){
                dispatch(setShowRelatedSubjectsModal(false))
            }else if(showCertificateImageModal){
                dispatch(setShowCertificateImageModal(false))
            }else if(showCourseModal){
                dispatch(setShowCourseModal(false))
            }else if (showCategoryModal){
                dispatch(setShowCategoryModal(false))
            }else if(showPlacementModal){
                dispatch(setShowPlacementModal(false))
            }else if (isModalOpen){
                setIsModalOpen(false)
            }else if(showCancellationScreen){
                dispatch(setShowCancellationScreen(false))
            }else if(showCartScreen){
                dispatch(setShowCartScreen(false))
            }
        }
        if(showRelatedSubjectsModal || showCertificateImageModal || showCourseModal || showCategoryModal || showPlacementModal || isModalOpen || showCartScreen || showCancellationScreen){
            navigate(pathname)
        }
        
        window.addEventListener('popstate', handleBackButton)

        return () => {
            window.removeEventListener('popstate', handleBackButton)
        }
    
    }, [dispatch, isModalOpen, navigate, pathname, showCancellationScreen, showCartScreen, showCategoryModal, showCertificateImageModal, showCourseModal, showPlacementModal, showRelatedSubjectsModal])

    useEffect(()=>{
        const fetchData = async () => {
            try {
                dispatch(setAuthToken(token))
                dispatch(setFromSavedAnalysisPage(true))
                const response = await dispatch(getUserDetails(token)).unwrap()
                const { certified_user_skill_id, name, email, phone_number } = response
                dispatch(setUserDetails({ name, email, phone_number }))
                const userDetailsResponse = await dispatch(getUserFullDetails({ certified_user_skill_id })).unwrap()
                const { subject_name, quiz_details } = userDetailsResponse
                dispatch(setUserSkillDetails(subject_name))
                Mixpanel.identify(certified_user_skill_id)
                Mixpanel.track(constants.Mixpanel.SAVED_ANALYSIS_PAGE)
                Mixpanel.people.set({
                    $email: email,
                    "name": name,
                    "phoneNo": phone_number,
                    "skillName": subject_name,
                    "score": quiz_details?.quiz_score
                })
            } catch (error) {
                console.log(error.message)
            }
        }
        if (token){
            fetchData()
        }else{
            Mixpanel.track(constants.Mixpanel.ANALYSIS_PAGE)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if(!token && mcQuestions?.length < 10 && !typeformData?.is_paid && answers?.length < 10 && !fromSavedAnalysisPage){
            if(mcQuestions?.length === 0){
                if(fromLandingPage){
                    navigate(-1, { replace: true })
                    dispatch(setFromLandingPage(false))
                    return
                }
                navigate('/onboarding')
            }else{
                navigate(`/mcq/${mcQuestions?.length}`)
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [navigate, token, typeformData?.is_paid, fromSavedAnalysisPage])
    
    useEffect(()=>{
        const getLocation = async (email) => {
            try{
                const result = await dispatch(locationCheck({email : email})).unwrap()
                if (!result) {
                    dispatch(locationWithoutPermission({email : email}))
                }
            } catch (error) {
                console.log(error.message)
            }
        }

        if(email){
            getLocation(email)
        }

    },[dispatch,email])

    useEffect(() => {
        dispatch(getLogoAndSalary({ subject: skillName, score}))
    }, [dispatch, score, skillName])

    useEffect(() => {
        dispatch(getWeeklyRanking({ subject: skillName, email }))
    }, [dispatch, email, skillName])

    useEffect(() => {
        productIds?.forEach((item) => {
            dispatch(getProductDetails({ certified_product_id: item }))

        })
        dispatch(setFromAnalysisPage(false))  
    }, [dispatch])

    useEffect(() => {
        if(quizDetails?.id){
            dispatch(fetchMCQAnalysis({ certified_user_skill_quiz_id: quizDetails?.id }))
        }
    }, [dispatch, quizDetails?.id])

    const fetchPriceData = useCallback(async (productMapping) => {
        try {

            let productId

            if (skillIsBusinessManagement) {
                productId = productMapping.businessManagement
            } else if (fourNinetyNine.includes(skillName?.toLowerCase()) || landingPage?.utm_source === 'Exp_499' || skillName.toLowerCase().includes("advance") || skillName.toLowerCase().includes("advanced")) {
                productId = productMapping.fourNinetyNine
            }else if (landingPage?.utm_source === 'thedataschoool' && skillName === 'SQL') {
                productId = productMapping.dataSchoolSQL
            } else if (costlyCertificates?.includes(skillName?.toLowerCase()) || landingPage?.utm_source === 'Exp_299') {
                productId = productMapping.costlyCertificates
            } else if (cheapCertificates?.includes(skillName?.toLowerCase())) {
                productId = productMapping.cheapCertificates
            } else if (twoFortyNine?.includes(skillName?.toLowerCase())) {
                productId = productMapping.twoFortyNine
            } else {
                productId = 1
            }

            const response = await dispatch(getProductDetails({ certified_product_id: productId })).unwrap()
            dispatch(setPrice(response?.data))
        } catch (error) {
            console.error(error.message)
        }
    }, [dispatch, landingPage?.utm_source, skillIsBusinessManagement, skillName])

    useEffect(() => {
        fetchPriceData(productMapping)
    }, [dispatch, skillName, skillIsBusinessManagement, landingPage.utm_source, score, fetchPriceData])

    useEffect(() => {
        const fetchData = async () => {
            try {
                dispatch(fetchRelatedJobs({ subject: skillName }))
                dispatch(getRelatedSkills({ subject_name: skillName, n: 25 }))
                dispatch(fetchCourseSyllabus({ type: 'default', subject: skillName, goal: `Learn ${skillName}` }))
            } catch (error) {
                toast.error('Something Went Wrong!')
            }
        }
        if (skillName){
           fetchData()
        }
    }, [dispatch, skillName])

    useEffect(() => {
        if (utm_source){
            dispatch(setAnalysisPageUtmSource(utm_source))
        }
    }, [dispatch, utm_source])

    const originalPrice = useMemo(() => {

        let originalPrice = price?.original_price || 599
        let sum1 = threeCertificates ?  (skillIsBusinessManagement ? priceChart?.[37]?.original_price : priceChart?.[2]?.original_price) : 0
        let sum2 = fiveCertificates ? (skillIsBusinessManagement ? priceChart?.[38]?.original_price : priceChart?.[10]?.original_price) : 0
        let sum3 = sevenCertificates ? (skillIsBusinessManagement ? priceChart?.[39]?.original_price : priceChart?.[11]?.original_price) : 0
        let sum4 = personalisedSelected ? priceChart?.[4]?.original_price : 0
        let sum5 = proMembershipSelected ? priceChart?.[3]?.original_price : 0
        let sum6 = fourWeekPlacementFeature ? priceChart?.[34]?.original_price : 0
        let sum10 = selectedSkills?.length > 0 ? selectedSkills?.length * (199) : 0
        
        return originalPrice + sum1 + sum2 + sum3 + sum4 + sum5 + sum6 + sum10
    }, [fiveCertificates, fourWeekPlacementFeature, personalisedSelected, price?.original_price, priceChart, proMembershipSelected, selectedSkills?.length, sevenCertificates, skillIsBusinessManagement, threeCertificates])

    const discountPrice = useMemo(() => {

        let discountPrice = price?.price || 0
        let sum1 = threeCertificates ?  (skillIsBusinessManagement ? priceChart?.[37]?.price : priceChart?.[2]?.price) : 0
        let sum2 = fiveCertificates ? (skillIsBusinessManagement ? priceChart?.[38]?.price : priceChart?.[10]?.price) : 0
        let sum3 = sevenCertificates ? (skillIsBusinessManagement ? priceChart?.[39]?.price : priceChart?.[11]?.price) : 0
        let sum4 = !makePersonaliseCourseFree && personalisedSelected ? priceChart?.[4]?.price : 0
        let sum5 = proMembershipSelected ? priceChart?.[3]?.price : 0
        let sum6 = fourWeekPlacementFeature ? priceChart?.[34]?.price : 0
        let sum10 = selectedSkills?.length > 0 ? (Math.round((selectedSkills?.length * (199) * (1 - (Math.min(selectedSkills?.length * 5 /100, 0.5)))))) : 0

        return discountPrice + sum1 + sum2 + sum3 + sum4 + sum5 + sum6 + sum10
    }, [fiveCertificates, fourWeekPlacementFeature, makePersonaliseCourseFree, personalisedSelected, price?.price, priceChart, proMembershipSelected, selectedSkills?.length, sevenCertificates, skillIsBusinessManagement, threeCertificates])

    const addOnsNumber = useMemo(() => {
        const bundle = threeCertificates || fiveCertificates || sevenCertificates || selectedSkills?.length > 0 ? 1 : 0
        const personalise = personalisedSelected ? 1 : 0
        const proMemebrship = proMembershipSelected ? 1 : 0
        const fourWeekPlacement = fourWeekPlacementFeature ? 1 : 0
        return bundle + personalise + proMemebrship + fourWeekPlacement + 1
    }, [fiveCertificates, fourWeekPlacementFeature, personalisedSelected, proMembershipSelected, selectedSkills?.length, sevenCertificates, threeCertificates])

    useEffect(() => {
        let timer
        if (timerSeconds > 0) {
            timer = setInterval(() => {
                dispatch(decrementTime())
            }, 1000)
        }
        return () => clearInterval(timer)
    }, [dispatch, timerSeconds])

    useEffect(() => {
        if (!skillIsNotSeo && selectedSkills?.length > 0){
            const skillArray = selectedSkills.map((item) => {
                return { course_name: item }
            })
            dispatch(customCertifiedBundle({ course_list: skillArray, bundle_type: 'custom_discounted_certified_bundle', certified_user_skill_id: typeformData?.id }))
        }
    }, [dispatch, selectedSkills, skillIsNotSeo, typeformData?.id])

    useEffect(() => {
        const timer = setInterval(() => {
            setIndex((prev) => (prev + 1)%3)
        }, 4500)
        return () => clearInterval(timer)
    }, [])

    const handleNavigate = () => navigate('/analysis/certificate-bundle')

    const razorpayHandler = async (callback) => {
        const selectedItems = []
        selectedItems.push({
            product_slug: price?.product_slug,
            product_quantity: 1,
            entity_type: 'skill',
            entity_id: typeformData?.id
        })
        if (threeCertificates){
            selectedItems.push({
                product_slug: skillIsBusinessManagement ? 'bundle_type_2:3' : 'bundle:3',
                product_quantity: 1,
            })
        }
        if (fiveCertificates){
            selectedItems.push({
                product_slug: skillIsBusinessManagement ? 'bundle_type_2:5' : 'bundle:5',
                product_quantity: 1
            })
        }
        if (sevenCertificates){
            selectedItems.push({
                product_slug: skillIsBusinessManagement ? 'bundle_type_2:7' : 'bundle:7',
                product_quantity: 1,
            })
        }
        if (personalisedSelected && !makePersonaliseCourseFree){
            selectedItems.push({
                product_slug: 'personalized',
                product_quantity: 1,
                entity_type: 'skill',
                entity_id: typeformData?.id
            })
        }
        if (proMembershipSelected){
            selectedItems.push({
                product_slug: 'core_product_purchase',
                product_quantity: 1,
            })
        }
        if (fourWeekPlacementFeature){
            selectedItems.push({
                product_slug: 'placement_support_2',
                product_quantity: 1,
            })
        }
        if (selectedSkills?.length > 0 && customBundle?.id){
            selectedItems.push({
                product_slug: 'custom_discounted_certified_bundle',
                product_quantity: 1,
                entity_type: 'bundle',
                entity_id: customBundle?.id
            })
        }
        try {
            const response = await dispatch(createPaymentOrder({ items: selectedItems, utm_source: utmSource, scholarship_type: insufficientFundsError ? 'basic_discount' : '' })).unwrap()
            if (!response?.razorpay_order_id){
                throw new Error('Something Went Wrong!')
            }
            const options = {
                key: RAZORPAY_KEY,
                amount: `${ response?.order_cost * 100}`,
                currency: "INR",
                name: userName,
                image: "",
                order_id: response?.razorpay_order_id,
                modal: {
                    "ondismiss": function () {
                        dispatch(setShowCancellationScreen(true))
                        dispatch(setShowCartScreen(true))
                        if(score < 40){
                            dispatch(setMakePersonaliseCourseFree(true))
                            fetchPriceData(freeProductMapping)
                            if(!personalisedSelected){
                                dispatch(setPersonalisedSelected())
                            }
                        }
                    }
                },
                handler: (res) => {
                    getOrderStatusSuccess(res)
                },
                prefill: {
                    name: userName,
                    email: email,
                    contact: phoneNo,
                },
                notes: {
                    address: "Razorpay Corporate Office"
                },
                theme: {
                    color: "#26CBA1"
                }
            }
            const rzp1 = new Razorpay(options)
            rzp1.on("payment.failed", function (response) {
                getOrderStatusFailed(response)
            })
            rzp1.open()
        } catch (error) {
            console.log(error)
            toast.error('Something Went Wrong! Try Again')
        }finally{
            callback()
        }
    }
    
    const getOrderStatusSuccess = async (response) => {
        window.dataLayer.push({
            'event': 'Purchase',
            'pageTitle': 'Successful Payment Page', //some arbitrary name for the page/state
            'pageUrl': 'https://certified.learntube.ai/analysis/leaderboard/v2'
        })
        navigate('/analysis/leaderboard/v2')
    }

    const getOrderStatusFailed = async (response) => {
        if(response?.error?.reason === 'insufficient_funds'){
            dispatch(setRazorpayModalError('insufficient_funds'))
        }else{
            dispatch(setRazorpayModalError('network_issue'))
        }
        dispatch(setShowCancellationScreen(true))
    }
    
    const bundleMap = {
        1: {
            state: threeCertificates,
            setState: setThreeCertificates,
            selectedTrack: constants.Mixpanel.NEW_CART_PAGE_3_CERTIFICATE_BUNDLE_ON_CART_WAS_ADDED,
            removedTrack: constants.Mixpanel.NEW_CART_PAGE_3_CERTIFICATE_BUNDLE_ON_CART_WAS_REMOVED,
        },
        2: {
            state: fiveCertificates,
            setState: setFiveCertificates,
            selectedTrack: constants.Mixpanel.NEW_CART_PAGE_5_CERTIFICATE_BUNDLE_ON_CART_WAS_ADDED,
            removedTrack: constants.Mixpanel.NEW_CART_PAGE_5_CERTIFICATE_BUNDLE_ON_CART_WAS_REMOVED,
        },
        3: {
            state: sevenCertificates,
            setState: setSevenCertificates,
            selectedTrack: constants.Mixpanel.NEW_CART_PAGE_7_CERTIFICATE_BUNDLE_ON_CART_WAS_ADDED,
            removedTrack: constants.Mixpanel.NEW_CART_PAGE_7_CERTIFICATE_BUNDLE_ON_CART_WAS_REMOVED,
        },
    }

    const handleBundleSelection = (number) => {
        const bundle = bundleMap[number]
        if (bundle) {
            if (bundle.state) {
                Mixpanel.track(bundle.removedTrack)
                dispatch(bundle.setState(false))
            } else {
                Mixpanel.track(bundle.selectedTrack)
                dispatch(bundle.setState(true))
            }

            Object.keys(bundleMap).forEach((key) => {
                if (+key !== number) {
                    dispatch(bundleMap[+key].setState(false))
                }
            })
        }
    }

    const saveName = () => {
        dispatch(setNameToSavedData(userName))
        dispatch(setShouldPlaySecondAudio(false))
        dispatch(setUserName(''))
        dispatch(setShowRedirectionModal(false))
        dispatch(resetAnswers())
        dispatch(resetAddedQuestions())
    }

    const registerPageRedirection = () => {
        dispatch(setUserEmail(''))
        dispatch(setUserPhoneNo(''))
        dispatch(setShowRedirectionModal(false))
    }
    
    const backModalOptions = [
        {
            title: 'Home',
            tag: 'Want To Change Subject?',
            image: 'https://ik.imagekit.io/238r9emirjj/personalise-app-lesson/Frame%20427320406.svg?updatedAt=1738842914698',
            onClick: () => {
                Mixpanel.track(constants.Mixpanel.POWER_MINUTE_BACK_HOME_CLICKED, {
                    page: 'Analysis Page'
                })
                saveName()
                dispatch(setIsPowerMinuteQuizCompleted(false))
                dispatch(setFromLandingPage(true))
                dispatch(setOnlyQuizCompleted(false))
                dispatch(setShowNotReferralSection(true))
                dispatch(setShowLandingPageTrendingSkills(true))
                navigate('/')
            }
        },
        {
            title: 'Change Name & Restart Quiz',
            tag: 'Want To Edit Your Name?',
            image: 'https://ik.imagekit.io/238r9emirjj/personalise-app-lesson/Frame%2022281.svg?updatedAt=1738843149469',
            onClick: () => {
                Mixpanel.track(constants.Mixpanel.POWER_MINUTE_BACK_EDIT_NAME_CLICKED, {
                    page: 'Analysis Page'
                })
                saveName()
                dispatch(resetScenarioDetails())
                dispatch(setIsPowerMinuteQuizCompleted(false))
                dispatch(setScenarioMap())
                dispatch(setOnlyQuizCompleted(false))
                dispatch(resetBadgeState())
                navigate('/onboarding')
            }
        },
        {
            title: 'Change Number & Email',
            tag: 'Want To Change Subject?',
            image: 'https://ik.imagekit.io/238r9emirjj/personalise-app-lesson/Frame%20427320406.svg?updatedAt=1738842914698',
            onClick: () => {
                Mixpanel.track(constants.Mixpanel.BACK_MODAL_EDIT_EMAIL_AND_NUMBER_CLICKED, {
                    page: 'Analysis Page'
                })
                registerPageRedirection()
                navigate(`/register`)
            }
        },
    ]

    const navigateToHome = () => {
        if(fromSavedAnalysisPage){
            return navigate('/')
        }
        dispatch(setShowRedirectionModal(true))
    }

    const handleCartIcon = () => dispatch(setShowCartScreen(true))

    const showBlurredScore = ((!fromSavedAnalysisPage && score < 70) || (fromSavedAnalysisPage && score < 60))

    const content = score === 50 ? <span>A <span className='title-text'>Good</span></span> : score === 60 ? <span>A <span className='title-text'>Great</span></span> : score === 70 ? <span> An <span className='title-text'>Awesome</span></span> : score === 80 || score === 90 ? <span> An <span className='title-text'>Excellent</span></span> : <span> A <span className='title-text'>Perfect</span></span>
    
    return (
        <div onScroll={handleScroll} className='w-full h-screen overflow-y-auto  flex-1 flex flex-col relative'
            style={{
                background: 'radial-gradient(53.11% 56.94% at 50% 50%, #244767 0%, #172C3F 100%)'
            }}
        >
            <div className='flex-1 w-full max-w-2xl mx-auto text-white p-4'>
                    <div className='mb-4'>
                        <Logos margin={'mx-auto'} navigateToHome={navigateToHome}/>
                    </div>
                {!showCartScreen ? <div className='main-page mt-2'>
                    {visitedAnalysisCartPage && <div className='absolute -top-[70px] right-0'>
                        <Suspense fallback={<ClipLoader />}>
                            <CartIcon
                                addOnsNumber={addOnsNumber}
                                handleCartIcon={handleCartIcon}
                            />
                        </Suspense>
                    </div>}
                    {score < 50 ? <h1 className='text-2xl font-medium'>Awesome {firstName}! <span className='title-text'>Test Completed!</span> 🚀</h1> : <h1 className='text-2xl font-medium'>Congrats {firstName}! You Scored {content} <span className='title-text'><span className={`${showBlurredScore && 'blur-[5px]'}`}>{showBlurredScore ? <BlurredScoreCanvas /> : score}</span>%!</span> 🚀</h1>}
                    <p className='text-lg text-white/70 leading-[140%] mt-0.5'>Unlock Instant Certificate To {((fromSavedAnalysisPage && score < 60) || (!fromSavedAnalysisPage && score < 70))  && 'View Score &'} Prove You’re In The <span className='font-bold text-span_color'>Top {score === 60 ? 18 : score === 70 ? 14 : score === 80 ? 9 : score === 90 ? 7 : score === 100 ? 4 : 10}%</span> Of <span className='font-bold text-span_color'>{skillName} Candidates</span></p>
                    <NewPriceCard
                        originalPrice={originalPrice}
                        discountPrice={discountPrice}
                        handleNavigate={handleNavigate}
                        skillName={skillName}
                        score={score}
                        visitedAnalysisCartPage={visitedAnalysisCartPage}
                        innerRef={ref}
                    />
                    <div className='my-9'>
                        <RemainingTime
                            minutes={minutes}
                            seconds={seconds}
                            title={<h4 className='text-sm text-center'>Unlock Now! Your Result Is <span className='text-danger font-bold'>Saved For 15 Mins</span></h4>}
                        />
                    </div>
                    <div className='mt-9'>
                        <NewRecognisedSection
                            swiperInstance={swiperInstance} 
                            setSwiperInstance={setSwiperInstance}
                        />
                    </div>
                    <Suspense fallback={<DesktopTrendingPageLoader />}>
                        <OurCertificateHelps />
                    </Suspense>
                    <Suspense fallback={<DesktopTrendingPageLoader />}>
                        <NewProfessionalAtCompany />
                    </Suspense>
                    <Suspense fallback={<DesktopTrendingPageLoader />}>
                        <QuizAnalysis
                            score={score}
                            skillName={skillName}
                            handleNavigate={handleNavigate}
                            showBlurredScore={showBlurredScore}
                        />
                    </Suspense>
                    {ourUsersModal && <UsersModal
                        isOpen={ourUsersModal}
                        setIsOpen={setOurUsersModal}
                    />}
                    <Suspense fallback={<DesktopTrendingPageLoader />}>
                        <NewAwardSection
                            index={index}
                        />
                    </Suspense>
                    <Suspense fallback={<DesktopTrendingPageLoader />}>
                        <JoinUs />
                    </Suspense>
                    <Suspense fallback={<DesktopTrendingPageLoader />}>
                        <ShwetaSingh />
                    </Suspense>
                    <Suspense fallback={<DesktopTrendingPageLoader />}>
                        <UnlockCertificateSection
                            skillName={skillName}
                            handleNavigate={handleNavigate}
                            visitedAnalysisCartPage={visitedAnalysisCartPage}
                            quizAnalysis={quizAnalysis}
                            score={score}
                        />
                    </Suspense>
                    <div className='mt-9'>
                        <h2 className='text-2xl font-medium text-center mb-4'>Frequently <span className='text-[28px] font-bold text-span_color'>Asked</span> Questions</h2>
                        <Suspense fallback={DesktopTrendingPageLoader}>
                            <NewFaqSection
                                certifiedFaq={certifiedFaq}
                            />
                        </Suspense>
                    </div>
                    <Suspense fallback={DesktopTrendingPageLoader}>
                        <LinkedInPosts />
                    </Suspense>
                    <div className='h-[100px]' />
                    
                </div> : <Suspense fallback={<NewLoader />}>
                    <NewCartScreen
                        originalPrice={originalPrice}
                        discountPrice={discountPrice}
                        handleBundleSelection={handleBundleSelection}
                        razorpayHandle={razorpayHandler}
                        showCancellationScreen={showCancellationScreen}
                    />
                </Suspense>}
                <AnimatePresence>
                    {(!showCartScreen && isVisible && !inView) && (
                        <motion.div
                            initial={{ opacity: 0, y: 50 }} // Start hidden and lower
                            animate={{ opacity: 1, y: 0 }} // Fade in and slide up
                            exit={{ opacity: 0, y: 50 }} // Animate out smoothly
                            transition={{ duration: 0.4, ease: "easeOut" }} 
                            className="max-w-3xl fixed z-30 bottom-0 left-0 right-0 mx-auto w-full bg-bg-3 px-4 py-2.5 text-center"
                        >
                            <MiniTimer minutes={minutes} seconds={seconds} title="Discount Ends In" />
                            <GetMyCertificateButton
                                originalPrice={originalPrice}
                                discountPrice={discountPrice}
                                handleNavigate={handleNavigate}
                                event={constants.Mixpanel.ANALYSIS_PAGE_STICKY_PAYMENT_BUTTON_WAS_CLICKED}
                            />
                        </motion.div>
                    )}
                </AnimatePresence>
                {showCertificateImageModal && <Suspense fallback={<NewLoader />}>
                    <CertificateImageModal />
                </Suspense>}
                {showCourseModal && <Suspense fallback={<NewLoader />}>
                    <NewCourseDetailsModal />
                </Suspense>}
                {showCategoryModal && <Suspense fallback={<NewLoader />}>
                    <CategoryModal />
                </Suspense>}
                {showRelatedSubjectsModal && <Suspense fallback={<NewLoader />}>
                    <RelatedSubjectsModal />
                </Suspense>}
                {newShowPlacementSupportModal && <Suspense fallback={<NewLoader />}>
                    <NewPlacementSupportModal />
                </Suspense>}
                {showCancellationScreen && <Suspense fallback={<NewLoader />}>
                    <NewCancellationModal
                        razorpayHandler={razorpayHandler}
                        originalPrice={originalPrice}
                        discountPrice={discountPrice}
                        addOnsNumber={addOnsNumber}
                    />
                </Suspense>}
                {showNewCourseSyllabusModal && <Suspense fallback={<NewLoader />}>
                    <NewCourseSyllabusModal
                        showNewCourseSyllabusModal={showNewCourseSyllabusModal}
                        skillName={skillName}
                        price={priceChart?.[21]}
                        id={typeformData?.id}
                        utmSource={utmSource}
                    />
                </Suspense>}
                {showAddOnBundleModal && <Suspense fallback={<NewLoader />}>
                    <CertificateAddOnBundleModal
                        handleBundleSelection={handleBundleSelection}
                    />
                </Suspense>}
                {showSkillList && <Suspense fallback={<NewLoader />}>
                    <NewSkillListModal
                        showSkillList={showSkillList}
                    />
                </Suspense>}
                {showRecognisedSection && <Suspense fallback={<NewLoader />}>
                    <NewRecognisedSectionModal 
                        showRecognisedSection={showRecognisedSection} 
                        swiperInstance={swiperInstance} 
                        setSwiperInstance={setSwiperInstance}  
                    />
                </Suspense>}
                {showRedirectionModal && <Suspense fallback={<NewLoader />}>
                    <NewRedirectionModal
                        showRedirectionModal={showRedirectionModal}
                        backModalOptions={backModalOptions}
                        openingEvent={constants.Mixpanel.ANALYSIS_PAGE_BACK_MENU_OPENED}
                    />
                </Suspense>}
            </div>        
        </div>        
    )
}

export default NewAnalysisPage